import { http } from "./httpServices";
import { MERCHANTS } from "./constants";

export function fetchAllMerchants(
  activePage: number,
  limitCount: number,
  queryString: string
) {
  return http.get(
    `${MERCHANTS}?page=${activePage}&limit=${limitCount}&searchText=${queryString}`
  );
}

export function fetchReportMerchants(
  activePage: number,
  limitCount: number,
  queryString: string
) {
  return http.get(
    `${MERCHANTS}?page=${activePage}&limit=${limitCount}&searchText=${queryString}&type=report`
  );
}

export function fetchMerchantDetails(id: string | undefined) {
  return http.get(`${MERCHANTS}/${id}`);
}

export function addMerchant(data: {
  name: string;
  outlet: string;
  email: string;
  role: any;
  status: string;
  password: string;
}) {
  return http.post(MERCHANTS, data);
}

export function updateMerchant(
  data: {
    name: string;
    outlet: string;
    email: string;
    role: any;
    status: string;
    password: string;
  },
  id: string | number | any
) {
  return http.put(`${MERCHANTS}/${id}`, data);
}
